import { AGE_RANGE_DISPLAY_MAP, INSTAGRAM_CREATOR_AGE_BUCKET } from '../../instagram/types/instagram-creator-age-bucket';
import { COUNTRY_DISPLAY_NAME_MAP, INSTAGRAM_CREATOR_COUNTRY } from '../../instagram/types/instagram-creator-country';
import { GENDER_DISPLAY_NAME_MAP, INSTAGRAM_CREATOR_GENDER } from '../../instagram/types/instagram-creator-gender';
import { INSTAGRAM_CREATOR_INTEREST, INTEREST_DISPLAY_NAME_MAP } from '../../instagram/types/instagram-creator-interests';
import { AgeOption, CountryOption, EngagementOption, FollowerOption, GenderOption, InterestOption } from './types';

// Define age options config
export const ageOptions: AgeOption[] = Object.entries(INSTAGRAM_CREATOR_AGE_BUCKET)
  .map(([, value]) => ({
    label: AGE_RANGE_DISPLAY_MAP[value],
    value
  }));

// Define gender options config
export const genderOptions: GenderOption[] = Object.entries(INSTAGRAM_CREATOR_GENDER)
  .map(([, value]) => ({
    label: GENDER_DISPLAY_NAME_MAP[value],
    value
  }));

// Define interest options config
export const interestOptions: InterestOption[] = Object.entries(INSTAGRAM_CREATOR_INTEREST)
  .map(([, value]) => ({
    label: INTEREST_DISPLAY_NAME_MAP[value],
    value
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

// Define follower options config
export const followerOptions: FollowerOption[] = [
  { label: '0', value: 0 },
  { label: '10K', value: 10000 },
  { label: '25K', value: 25000 },
  { label: '50K', value: 50000 },
  { label: '75K', value: 75000 },
  { label: '100K', value: 100000 },
];

// Define engagement options config
export const engagementOptions: EngagementOption[] = [
  { label: '0', value: 0 },
  { label: '2K', value: 2000 },
  { label: '10K', value: 10000 },
  { label: '50K', value: 50000 },
  { label: '100K', value: 100000 },
];

// Define countries options config
export const countriesOptions: CountryOption[] = Object.entries(INSTAGRAM_CREATOR_COUNTRY)
  .map(([, value]) => ({
    label: COUNTRY_DISPLAY_NAME_MAP[value],
    value
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
